import { Component, EventEmitter, inject, Input, model, Output, Self, SkipSelf } from '@angular/core';
import { entre0Y100 } from '../../../validators/transformations';
import { UsuarioCouchBase } from '../../../model/usuario';
import { FormsModule } from '@angular/forms';
import { HijoService } from '../../../services/hijo.service'; // Assuming hijoService is defined in this path
import { PadreService } from '../../../services/padre.service';

@Component({
  selector: 'app-test-hijo-angular',
  imports: [FormsModule],
  providers: [
     { provide: PadreService, useValue: {nombre: "hijo"} }
  ],
  templateUrl: './test-hijo-angular.component.html',
  styleUrl: './test-hijo-angular.component.css'
})
export class TestHijoAngularComponent {
  // Primero lo hacemos con el deprectado @Input y @Output y luego lo hacemos con el nuevo @Signal
  // Para probar propiedad de componente que admite entrada desde fuera y si el componente lo cambia, emite un evento de salida
  @Input({required: true, transform: entre0Y100}) inputProperty: number = -1;
  @Output() inputPropertyChange = new EventEmitter<number>();
  @Input() usuario?: Partial<UsuarioCouchBase>;
  // Si pongo true no busca en el elemento host declarado en providers y cogeria el del padre. Si pongo false coge el servicio hijo
  public service = inject(PadreService, {skipSelf: true});
  //  Ahora con signals
  inputPropertySignal = model(0)

  constructor(){
    console.log(`TestHijoAngularComponent:: constructor() service.nombre: ${this.service.nombre}`);
  }

  inc() {
    this.resize(1);
    this.inputPropertySignal.update(value => value + 1);
  }
  dec() {
    this.resize(-1);
    this.inputPropertySignal.update(value => value - 1);
  }
  resize(delta: number){
    console.log(`** Resizing inputProperty: ${this.inputProperty} by ${delta}`);
    this.inputProperty += delta;
    this.inputPropertyChange.emit(this.inputProperty);
  }
  

}
